import { render, staticRenderFns } from "./Dia.vue?vue&type=template&id=1c38df36&"
import script from "./Dia.vue?vue&type=script&lang=js&"
export * from "./Dia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports